import { IInsideMultiBetArea } from '@bg-shared/interfaces/RNGRoulette';
import { RouletteDefinition } from './RouletteDefinition';

export class EuroRouletteDefinition {
    private static insideBetsOrder = [
        0, 32, 15, 19, 4, 21, 2, 25, 17, 34, 6, 27, 13, 36, 11, 30, 8, 23, 10, 5, 24, 16, 33, 1, 20,
        14, 31, 9, 22, 18, 29, 7, 28, 12, 35, 3, 26,
    ];

    public static insideBets = RouletteDefinition.generateInsideBets(
        EuroRouletteDefinition.insideBetsOrder,
    );

    public static START_SIDE_SECTORS_EURO = EuroRouletteDefinition.insideBets.slice(21, 34); // [16, 33, 1, 20, 14, 31, 9, 22, 18, 29, 7, 28, 12]

    public static END_SIDE_SECTORS_EURO = EuroRouletteDefinition.insideBets.slice(2, 15).reverse(); // [11, 36, 13, 27, 6, 34, 17, 25, 2, 21, 4, 19, 15]

    public static START_CORNER_SECTORS_EURO = EuroRouletteDefinition.insideBets.slice(15, 21); // [30, 8, 23, 10, 5, 24]

    public static END_CORNER_SECTORS_EURO = [
        ...EuroRouletteDefinition.insideBets.slice(34, 38),
        ...EuroRouletteDefinition.insideBets.slice(0, 2),
    ]; // [35, 3, 26, 0, 32]

    public static insideBetsMap = RouletteDefinition.generateInsideBetsMap(
        EuroRouletteDefinition.insideBets,
    );

    public static insideMultiBetsMap = EuroRouletteDefinition.insideBets.reduce<
        Record<number, Partial<Record<IInsideMultiBetArea, number[]>>>
    >((finalValue, sector) => {
        const { value } = sector;

        if (value === 0) {
            return finalValue;
        }

        if (value <= 3) {
            // split bet with 0
            finalValue[value].splitZero = [0, value];

            if (value === 1) {
                // basket bet
                finalValue[value].basket = Array(4)
                    .fill(null)
                    .map((_, index) => index);
            } else if (value === 2 || value === 3) {
                // square bet with 0
                finalValue[value].squareZero = [0, value - 1, value];
            }
        }

        return finalValue;
    }, RouletteDefinition.generateCommonInsideMultiBetsMap(EuroRouletteDefinition.insideBets));
}
